import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LocalDataSource } from 'ng2-smart-table';
import { NbDialogService } from '@nebular/theme';
import { ToasterService } from '../../../../shared/services/toaster.service';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { ModalConfirmComponent } from '../../../../shared/components/modals/confirm/modal-confirm.component';

@Component({
  selector: 'app-companies-frac-spread',
  templateUrl: './frac-spread.component.html',
  styleUrls: ['./frac-spread.component.scss']
})
export class CompaniesFracSpreadComponent implements OnInit {

  pattern: any = /^[-_A-Za-z0-9\s]*((-_\s)*[-_A-Za-z0-9\s])*$/;
  hideButton: boolean = false;
  maxFSpread: number = 0;
  data: any[] = [];
  tableSettings = {
    actions: {
      columnTitle: 'Action'
    },
    edit: {
      editButtonContent: '<i class="icon-edit app-main-color-fg app-font-size-normal"></i>',
      saveButtonContent: '<i class="icon-check  app-main-color-fg app-font-size-normal"></i>',
      cancelButtonContent: '<i class="icon-cancel app-danger-color-fg app-font-size-normal"></i>',
      confirmSave: true,
    },
    delete: {
      deleteButtonContent: '<i class="icon-delete app-danger-color-fg app-font-size-normal"></i>',
      confirmDelete: true,
    },
    hideSubHeader: true,
    pager: {
      perPage: 15,
    },
    columns: {
      name: {
        title: 'Name',
        type: 'string',
        width: '95%',
        sort: false,
      },
    },
  };

  dataSource: any = new LocalDataSource();

  form: FormGroup;
  spreadName: AbstractControl;

  @Output() dataSpread: EventEmitter<any> = new EventEmitter();

  @Input()
  set listFSpr(list: any) {
    if (list) {
      this.dataSource.load(list);
      this.getData();
    }
  }
  @Input()
  set maxFracSpread(num: number) {
    this.maxFSpread = num;
    if (this.maxFSpread <= this.data.length ) {
      this.hideButton = true;
    } else {
      this.hideButton = false;
    }
  }

  constructor(private dialogService: NbDialogService,
              private toasterService: ToasterService) {
    this.createForm();
  }

  createForm() {
    this.form = new FormGroup({
      spreadName: new FormControl('', Validators.compose([
        Validators.required, Validators.minLength(2),
        Validators.maxLength(50),
        Validators.pattern(this.pattern)])
      ),
    });
    this.spreadName = this.form.controls['spreadName'];
  }

  ngOnInit() {
  }

  onEditConfirm(event): void {
    if (event) {
      event.newData.name = event.newData.name.trim();
      event.newData.name = event.newData.name.replace(/\s+/g, ' ');
      const name = event.newData.name.trim();
      if (this.data.findIndex(item => (item.name === name && event.data.name !== name)) === -1) {
        if (name.length >= 2 && name.length <= 50 && this.pattern.test(name)) {
          event.confirm.resolve(event.newData);
          setTimeout(() => {
            this.dataSpread.emit(this.getData());
          });
        } else {
          this.toasterService.showError('The FracSpread name has to be between 2 and 50 characters long and not contain special chars (except for "-", space, underscore).');
        }
      } else {
        this.toasterService.showError('This FracSpread already exists. Please provide a unique name.');
      }
    }
  }

  onDeleteConfirm(item): void {
    this.dialogService.open(ModalConfirmComponent, {
      context: {config: {
        title: 'Delete',
        message: `Are you sure you want to delete <br> <b class="h6">${item.data.name}</b>?`,
        className: 'pop-delete common-page',
        btnTxtConfirm: 'Yes',
        btnTxtCancel: 'No',
        data: item.data,
      }}
    }).onClose.subscribe(res => {
      if (res.confirm) {
        this.dataSource.remove(item.data);
        this.dataSpread.emit(this.getData());
      }
    });
  }

  getData() {
    const data = this.dataSource.getAll();
    this.data = data['__zone_symbol__value'];
    if (this.maxFSpread <= this.data.length ) {
      this.hideButton = true;
    } else {
      this.hideButton = false;
    }
    return this.data.map(item => ({name: item.name, id: (item.id ? item.id : 0)}));
  }

  onAddNew() {
    if (this.spreadName.errors) {
      this.toasterService.showError('The FracSpread name has to be between 2 and 50 characters long and not contain special chars (except for "-", space, underscore).');
    } else {
      if (this.data.findIndex(item => item.name === this.spreadName.value) === -1) {
        this.dataSource.prepend({name: this.spreadName.value});
        this.dataSpread.emit(this.getData());
        this.spreadName.setValue('');
      } else {
        this.toasterService.showError('This FracSpread already exists. Please provide a unique name.');
      }
    }
  }
}
